<template>
  <TableCardLayout>
    <template #table-controls>
      <TableControls :loading="downloading">
        <template #left>
          <div class="d-flex align-center gap-1">
            <LookupCommonChemistryCASRN
              button-title="mdi-text-box-search"
              max-width="700"
              title="Lookup CASRN using Commonchemistry API"
            />

            <ActivatorButton
              :v-btn-props="{ to: '/utils/datasources', class: 'flat-button border' }"
              icon-or-title="mdi-format-align-justify"
              tooltip-text="Pubchem Data Sources and Annotations"
            />

            <ActivatorButton
              icon-or-title="mdi-format-float-center"
              tooltip-text="Integrity check"
              :v-btn-props="{ to: '/utils/pubchem', class: 'flat-button border' }"
            />

            <ActivatorButton
              icon-or-title="mdi-arrange-send-to-back"
              tooltip-text="Build similarity matrix for selected chemicals"
              :v-btn-props="{ to: '/utils/simmap', class: 'flat-button border' }"
            />

            <FileUploadDialogUniversal
              :max-width="700"
              :options="options"
              :preflight-url="`${SERVICES_URL}/universalpreflight`"
              :upload-url="`${RESOLVER_URL}/universalharvest`"
              :workflows="workflows"
              button-title="mdi-file-arrow-up-down"
              title="Universal Harvest"
            />

            <ExportMenu
              v-model="downloading"
              :export-url="`${RESOLVER_URL}/export_classyfire`"
              :ignore-formats="['SMI']"
              :selected-structures="getCheckedStructures"
              :show-images="showImage"
              icon-name="mdi-fire"
              title="Export ClassyFire"
              file-name="ClassyFire"
              :activator-btn-props="{ class: 'flat-button border' }"
            />
          </div>
        </template>

        <!-- <template
        v-if="predictionResult?.result"
        #right
      >
        <v-switch
          v-model="showFailed"
          label="Show Failed"
          class="ma-2"
        />
        <v-switch
          v-model="showChanged"
          label="Show Changed"
          class="ma-2"
        />

        <v-switch
          v-model="showImage"
          label="Show Structure"
          class="ma-2"
        />

        <v-btn-toggle
          class="ml-3"
          dense
        >
          <ExportMenu
            v-if="predictionResult.result"
            v-model="downloading"
            :export-url="`${SERVICES_URL}/export_json_report`"
            :ignore-formats="['SMI']"
            :ready-report="predictionResult"
            :show-images="showImage"
            :file-name="exportFilename"
            title="Export Model report"
          />
        </v-btn-toggle>
      </template> -->
      </TableControls>
    </template>

    <!-- <v-card class="ma-1">
      <ChemCart @show-image-updated="handleShowImage">
        <template #header>
          <div
            v-if="predictionResult.modelDetails"
            class="mx-3 mt-2"
          >
            {{ predictionResult.modelDetails.propertyName }} ({{ predictionResult.modelDetails.modelName }})
          </div>

          <template v-if="predictionResult && predictionResult.result">
            <v-switch
              v-model="showFailed"
              label="Show Failed"
              class="ma-2"
            />
            <v-switch
              v-model="showChanged"
              label="Show Changed"
              class="ma-2"
            />
          </template>

          <v-btn-toggle
            class="ml-3"
            dense
          >
            <ExportMenu
              v-if="predictionResult.result"
              v-model="downloading"
              :export-url="`${SERVICES_URL}/export_json_report`"
              :ignore-formats="['SMI']"
              :ready-report="predictionResult"
              :show-images="showImage"
              :file-name="exportFilename"
              title="Export Model report"
            />
          </v-btn-toggle>
        </template>
      </ChemCart>

      <v-progress-linear
        v-if="downloading"
        indeterminate
      />

      <div
        v-if="predictionResult.message"
        class="predict-error"
      >
        {{ predictionResult.message }}
      </div>
    </v-card> -->
  </TableCardLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import { RESOLVER_URL, SERVICES_URL } from '@/main'
import FileUploadDialogUniversal from '@/components/dialogs/FileUploadDialogUniversal.vue'
import LookupCommonChemistryCASRN from '@/components/lookup/LookupCommonChemistryCASRN.vue'
import ExportMenu from '@/components/ExportMenu.vue'
import TableControls from '@/components/report-page-layouts/TableControls.vue'
import TableCardLayout from '@/components/report-page-layouts/TableCardLayout.vue'
import ActivatorButton from '@/components/ActivatorButton.vue'

export default {
  components: {
    ExportMenu,
    LookupCommonChemistryCASRN,
    FileUploadDialogUniversal,
    TableControls,
    ActivatorButton,
    TableCardLayout,
  },

  data() {
    return {
      downloading: null,
      showImage: true,
      workflows: [],
      options: null,
      SERVICES_URL,
      RESOLVER_URL,
      predictionResult: {},
      showFailed: false,
      showChanged: false,
    }
  },

  computed: {
    ...mapGetters(['getCheckedStructures', 'isAdmin', 'isAuthenticated', 'stdizerResult']),
    exportFilename() {
      return (
        (this.predictionResult?.resultType ?? 'model') +
        (this.predictionResult?.model ?? '') +
        (this.predictionResult?.modelDetails?.modelName ?? '')
      )
    },
  },

  methods: {
    maybeOpenChemCart() {
      if (!this.predictionResult?.result && !this.getCheckedStructures?.length)
        this.$store.commit('SET_VIEW_STRUCTURES', true)
    },
  },

  created() {
    this.maybeOpenChemCart()
  },
}
</script>

<style scoped>
.predict-error {
  padding: 1em;
  color: red;
}
</style>
